import { STEP_COUNT, type Step } from "../logic";

/** The bar is decoration; screen readers get "3단계 중 N단계". */
export function StepProgress({ step }: { step: Step }) {
  return (
    <div className="mt-6">
      <div aria-hidden className="h-1.5 w-full overflow-hidden rounded-full bg-fill-normal">
        <div
          className="h-full origin-left rounded-full bg-primary transition-transform duration-slow ease-standard"
          style={{ transform: `scaleX(${step / STEP_COUNT})` }}
        />
      </div>
      <p className="mt-2 text-label-1 tabular-nums text-label-neutral">
        <span aria-hidden>
          {step} / {STEP_COUNT}
        </span>
        <span className="sr-only">
          {STEP_COUNT}단계 중 {step}단계
        </span>
      </p>
    </div>
  );
}
